module.exports = __webpack_public_path__ + "static/media/wizualizacja-124.8208875d.png";